import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
const WrongP = styled.p `
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  font-size: 30px;
  text-align: center;
`;
const Details = styled.details `
  margin-top: 10px;
  white-space: pre-wrap;
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  color: red;
`;
export default function ErrorOverlay(props) {
    return (_jsxs("div", { style: { margin: 25 }, children: [_jsx(WrongP, { children: "Something went wrong." }), _jsxs(Details, { children: [_jsx("p", { style: { textDecoration: 'underline' }, children: props.error.message }), props.error.stack] })] }));
}
